import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { FormControl, FormGroup, Form } from "react-bootstrap";

export default class DefaultInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cursorPosition: 0,
    };
  }

  focus() {
    ReactDOM.findDOMNode(this.input).focus();
  }

  getInputDOMNode() {
    return ReactDOM.findDOMNode(this.input);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.fieldDidShrink(prevProps) || this.fieldDidExpand(prevProps)) {
      this.updateFieldCursorPosition();
    }
  }

  fieldDidExpand(prevProps) {
    return this.props.type === "textarea" && prevProps.type !== "textarea";
  }

  fieldDidShrink(prevProps) {
    return this.props.type === "text" && prevProps.type !== "text";
  }

  updateFieldCursorPosition() {
    this.focus();
    this.getInputDOMNode().setSelectionRange(
      this.state.cursorPosition,
      this.state.cursorPosition
    );
  }

  saveCursorPosition(e) {
    this.props.onChange(e);
    this.setState({
      cursorPosition: e.target.selectionStart,
    });
  }

  render() {
    switch (this.props.type) {
      case "radio":
        return this._renderRadio();
      case "checkbox":
        return this._renderCheckbox();
      case "select":
        return this._renderSelect();
      case "textarea":
        return this._renderTextArea();
      default:
        return this._renderInput();
    }
  }

  _renderCheckbox() {
    // TODO change control id to hash of label
    return (
      <Form.Group
        size="small"
        controlId={Math.floor(Math.random() * Number.MAX_SAFE_INTEGER)}
        className="mb-3"
      >
        <Form.Check
          type="checkbox"
          ref={(c) => (this.input = c)}
          {...this.props}
          label={this.props.label}
          className={this.props.validation.classname}
        />
        {this.props.validation.message}
      </Form.Group>
    );
  }

  _renderRadio() {
    return (
      <FormGroup size="small" className="mb-3">
        <Form.Check
          type="radio"
          ref={(c) => (this.input = c)}
          {...this.props}
          label={this.props.label}
          className={this.props.validation.classname}
        />
        {this.props.validation.message}
      </FormGroup>
    );
  }

  _renderSelect() {
    const { validation, children, value, ...rest } = this.props;
    return (
      <FormGroup size="small" className="mb-3">
        {this._renderLabel()}
        <FormControl
          as="select"
          value={value}
          className={validation.classname}
          ref={(c) => (this.input = c)}
          {...rest}
        >
          {children}
        </FormControl>
        {validation.message}
      </FormGroup>
    );
  }

  _renderLabel() {
    return this.props.label ? (
      <Form.Label>{this.props.label}</Form.Label>
    ) : null;
  }

  _renderTextArea() {
    // TODO validation
    return (
      <FormGroup size="small" className="mb-3">
        {this._renderLabel()}
        <FormControl
          ref={(c) => (this.input = c)}
          as="textarea"
          {...this.props}
          className={this.props.validation.classname}
          onChange={(e) => this.saveCursorPosition(e)}
        />
        {this.props.validation.message}
      </FormGroup>
    );
  }

  _renderInput() {
    return (
      <FormGroup size="small" className="mb-3">
        {this._renderLabel()}
        <FormControl
          className={this.props.validation.classname}
          ref={(c) => (this.input = c)}
          as="input"
          placeholder={this.props.placeholder}
          {...this.props}
          onChange={(e) => this.saveCursorPosition(e)}
        />
        {this.props.validation.message}
      </FormGroup>
    );
  }
}

DefaultInput.propTypes = {
  type: PropTypes.string,
  label: PropTypes.object,
  value: PropTypes.any,
  onChange: PropTypes.func,
  help: PropTypes.string,
  validation: PropTypes.object,
  placeholder: PropTypes.string,
};

DefaultInput.defaultProps = {
  type: "text",
};
